import React from 'react';
import { IconProps } from '.';

const SvgTwinkle = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M12 2.25a.75.75 0 0 1 .703.49l.663 1.792c.894 2.415 1.275 3.399 1.99 4.113.714.714 1.697 1.095 4.112 1.989l1.793.663a.75.75 0 0 1 0 1.406l-1.793.663c-2.415.894-3.398 1.276-4.113 1.99-.714.714-1.095 1.697-1.989 4.112l-.663 1.793a.75.75 0 0 1-1.406 0l-.663-1.793c-.894-2.415-1.275-3.398-1.99-4.113-.714-.713-1.697-1.095-4.112-1.989l-1.793-.663a.75.75 0 0 1 0-1.406l1.793-.663c2.415-.894 3.398-1.275 4.113-1.99.714-.713 1.095-1.697 1.989-4.112l.663-1.793.049-.105A.75.75 0 0 1 12 2.25Zm0 2.91c-.822 2.221-1.31 3.56-2.295 4.545C8.72 10.69 7.381 11.178 5.16 12c2.222.822 3.561 1.31 4.546 2.295.985.985 1.473 2.324 2.295 4.545.822-2.221 1.31-3.56 2.295-4.545.985-.985 2.324-1.473 4.545-2.295-2.221-.822-3.56-1.31-4.545-2.295C13.31 8.72 12.822 7.381 12 5.16Z'
      />
    </svg>
  );
};

export default SvgTwinkle;
